import FileDownloadToasts from './components/downloads/FileDownloadToasts'
import 'bootstrap/dist/css/bootstrap.min.css'
import React, { useContext, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import NotFoundPage from './NoMatchPage'
import ActivitiesIndexView from './asset_report/ActivitiesIndexView'
import CollectionsIndexView from './asset_report/CollectionsIndexView'
import ShowAssetApp from './asset_report/ShowAssetApp'
import ShowCollectionApp from './asset_report/ShowCollectionApp'
import ChargeIndexView from './charge/ChargeIndexView'
import ClientApplicationApp from './client/ClientApplicationApp'
import ClientApplicationForm from './client/ClientApplicationForm'
import ClientIndexApp from './client/ClientIndexApp'

import CreateNewClientView from './client/CreateNewClientView'
import ShowClientApp from './client/ShowClientApp'
import { ClientProvider } from './client/context/ClientContext'
import CreateUsersForm from './config_user/CreateUsersForm'
import TabsUserConfig from './config_user/TabsUserConfig'
import UsersIndexApp from './config_user/UsersIndexApp'
import { UserConfigProvider } from './config_user/context/UserConfigProvider'
import { UserInfoProvider } from './config_user/context/UserInfoProvider'
import { UserStepTabsProvider } from './config_user/context/UserStepTabsProvider'
import './css/index.css'
import './css/styles.scss'
import AssignDeliveryView from './delivery/AssignDeliveryView'
import OrderOcIndex from './poc/PurchaseOrder/OrderOcIndex'
import MetricsIndex from './poc/PocReports/MetricsIndex'
import FillRateProductDifferences from './poc/PocReports/FillRateProductDifferences'
import ShowOcView from './poc/PurchaseOrder/show/ShowOcView'

import StoreRelationsIndex from './poc/StoreRelations/StoreRelationsIndex'
import ShowStoreView from './poc/StoreRelations/show/ShowStoreView'
import StoreRelationFormView from './poc/StoreRelations/form/StoreRelationFormView'

import DeliveryIndexView from './delivery/DeliveryIndexView'
import DeliveryIndexBoardView from './delivery/delivery_on_board_sale/DeliveryIndexBoardView'
import EssentialIndexView from './essential/EssentialIndexView'
import EssentialsAssociationsView from './essential/EssentialsAssociationsView'
import { GlobalContext } from './global_context/GlobalContext'
import MainLayout from './layout/MainLayout'
import ConfirmNewPasswordPage from './login/ConfirmNewPasswordPage'
import LoginPage from './login/LoginPage'
import Logout from './login/Logout'
import ResetPasswordPage from './login/ResetPasswordPage'
import OrderIndexApp from './order/OrderIndexApp'
import ShowOrderApp from './order/ShowOrderApp'
import PointOfSaleApp from './pos/PointOfSaleApp'
import PosDownloadApp from './pos/PosDownloadApp'
import PosTaskEffectivityApp from './pos/PosTaskEffectivityApp'
import PosDetailsApp from './pos/details/PosDetailsApp'
import TaskLayout from './pos/forms/TaskLayout'
import CreatePriceList from './price/price_list/CreatePriceList'
import PriceListIndexApp from './price/price_list/PriceListIndexApp'
import ShowPriceListView from './price/price_list/ShowPriceListView'
import ProductIndexApp from './product/ProductIndexApp'
import ShowProductApp from './product/ShowProductApp'
import { PriceListCreateProvider } from './product/context/PriceListCreateProvider'
import { ProductCreateProvider } from './product/context/ProductCreateProvider'
import { SubmitCreateProductProvider } from './product/context/SubmitCreateProductProvider'
import CreateProductStep from './product/page/CreateProductStep'
import CreatePromoApp from './promo/CreatePromoApp'
import PromoIndexApp from './promo/PromoIndexApp'
import ShowPromoView from './promo/ShowPromoView'
import QuoteIndexApp from './quote/index/QuoteIndexApp'
import ShowQuoteApp from './quote/show/ShowQuoteApp'
import RefundIndexView from './refunds/index/RefundIndexView'
import ShowChargeApp from './charge/ShowChargeApp'
import ShowDeliveryApp from './delivery/ShowDeliveryApp'
import ShowInvoiceApp from './invoice/ShowInvoiceApp'
import ShowNoEffectiveVisitApp from './report/no-effective-visit/ShowNoEffectiveVisitApp'
import PosTaskApp from './pos/task_details/PosTaskApp'
import ShowRefundApp from './refunds/show/ShowRefundApp'
import EffectivenessIndexApp from './report/unified/EffectivenessIndexApp'
import ShowUserView from './report/unified/ShowUserView'
import CreateNewRoutePlan from './route/CreateNewRoutePlan'
import RoutePlanIndexView from './route/RoutePlanIndexView'
import ShowRoutePlanView from './route/ShowRoutePlanView'
import SegmentIndexApp from './segments/SegmentIndexApp'
import SettlementsDetails from './settlements/SettlementsDetails'
import SettlementsIndex from './settlements/SettlementsIndex'
import DailySettlementControlApp from './settlements/daily-control/DailySettlementControlApp'
import CreateSpecialPrice from './price/special_price/form/CreateSpecialPrice'
import ShowSpecialPriceView from './price/special_price/ShowSpecialPriceView'
import SpecialPriceIndexView from './price/special_price/SpecialPriceIndexView'
import UsersByClientRoute from './client/details/usersByClientRoute'
import RbacRolesListPage from './rbac/roles/pages/RbacRolesListPage'
import RbacRoleDetailPage from './rbac/roles/pages/RbacRoleDetailPage'
import CreateRbacRoleWizard from './rbac/roles/RoleWizard/CreateRbacRoleWizard'
import AssignRbacRolesPage from './rbac/pages/AssignRbacRolesPage'
import RbacUserDetailPage from './rbac/pages/RbacUserDetailPage'
import ActivateAccountPage from './login/ActivateAccountPage'
import { canViewRefunds } from './global_context/capabilities/refundCapabilities'
import {
  canManagePosTasks,
  canViewPosAnalysisDownload,
  canViewPosEffectiveness,
  canViewPosTasks
} from './global_context/capabilities/posCapabilities'
import {
  canManageRbacRoles,
  canViewRbacRoles,
  canViewRbacUsers
} from './global_context/capabilities/rbacManagementCapabilities'
import { canManageClients, canViewClientApplications, canViewClients } from './global_context/capabilities/clientCapabilities'
import { canManageProducts, canViewProducts } from './global_context/capabilities/productCapabilities'
import { canViewSegments } from './global_context/capabilities/segmentCapabilities'
import { canViewEssentials } from './global_context/capabilities/essentialCapabilities'
import {
  canManagePriceLists,
  canManageSpecialPrices,
  canViewPriceLists,
  canViewSpecialPrices
} from './global_context/capabilities/priceCapabilities'
import { canManagePromotions, canViewPromotions } from './global_context/capabilities/promoCapabilities'
import {
  canManagePocStoreRelations,
  canViewPocFillRate,
  canViewPocOrders,
  canViewPocStoreRelations
} from './global_context/capabilities/pocCapabilities'
import { canViewOrders } from './global_context/capabilities/orderCapabilities'
import { canViewQuotes } from './global_context/capabilities/quoteCapabilities'
import { canViewAssignDeliveries, canViewDeliveries } from './global_context/capabilities/deliveryCapabilities'
import { canViewOnBoardSales } from './global_context/capabilities/onBoardSaleCapabilities'
import { canViewAssetReports, canViewCloseAssets } from './global_context/capabilities/assetCapabilities'
import { canViewSettlements, canViewDailySettlementControl } from './global_context/capabilities/settlementCapabilities'
import { canViewReports } from './global_context/capabilities/reportCapabilities'
import { canManageUsersApp, canViewUsersApp } from './global_context/capabilities/userAppCapabilities'
import { canViewCharges } from './global_context/capabilities/chargeCapabilities'
import { canManageRoutePlans, canViewRoutePlans } from './global_context/capabilities/routePlanCapabilities'

import { initSentry } from './helpers/initSentry'
import ProtectedSentryRoute from './utils/ProtectedSentryRoute'
import { useAuth } from './auth/AuthContext'
import LoadingScreen from './components/LoadingScreen'
import HomeIndexApp from './home/HomeIndexApp'
import MfaLoginPage from './login/MfaLoginPage'
import MyProfileApp from './profile/user/MyProfileApp'

const App = () => {
  const { shouldViewCoreInfo, redirectPath, isReady } = useContext(GlobalContext)
  const { isAuthenticated, isBootstrapping } = useAuth()

  useEffect(() => {
    initSentry()
  }, [])

  if (!isReady || isBootstrapping) {
    return (
      <MainLayout>
        <LoadingScreen text="Cargando..." minHeight="calc(100dvh - 160px)" />
      </MainLayout>
    )
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/cambiar-contrasena" element={<ResetPasswordPage />} />
        <Route path="/nueva-contrasena/:token" element={<ConfirmNewPasswordPage />} />
        <Route path="/nueva-contrasena" element={<ConfirmNewPasswordPage />} />
        <Route path="/login/mfa" element={<MfaLoginPage />} />
        <Route path="/activate-account" element={<ActivateAccountPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    )
  }

  return (
    <MainLayout>
      <FileDownloadToasts />
      <Routes>
        <Route path="/" element={<Navigate to="/inicio" replace />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/activate-account" element={<ActivateAccountPage />} />
        <Route path="/inicio" element={<HomeIndexApp />} />
        <Route path="/perfil" element={<MyProfileApp />} />
        <Route path="/perfil/seguridad" element={<MyProfileApp />} />
        <Route
          path="/productos"
          element={
            <ProtectedSentryRoute
              visible={canViewProducts()}
              redirect={redirectPath}
              element={<ProductIndexApp />}
            />
          }
        />

        <Route
          path="/crear_producto"
          element={
            <ProtectedSentryRoute
              visible={canManageProducts()}
              redirect={redirectPath}
              element={
                <ProductCreateProvider>
                  <PriceListCreateProvider>
                    <SubmitCreateProductProvider>
                      <CreateProductStep />
                    </SubmitCreateProductProvider>
                  </PriceListCreateProvider>
                </ProductCreateProvider>
              }
            />
          }
        />

        <Route
          path="/productos/:id/detalles/"
          element={
            <ProtectedSentryRoute
              visible={canViewProducts()}
              redirect={redirectPath}
              element={<ShowProductApp />}
            />
          }
        />

        <Route
          path="/clientes"
          element={
            <ProtectedSentryRoute
              visible={canViewClients()}
              redirect={redirectPath}
              element={<ClientIndexApp />}
            />
          }
        />
        <Route
          path="/crear_cliente"
          element={
            <ProtectedSentryRoute
              visible={canManageClients()}
              redirect={redirectPath}
              element={<CreateNewClientView />}
            />
          }
        />

        <Route
          path="/clientes/:id/detalles/"
          element={
            <ProtectedSentryRoute
              visible={canViewClients()}
              redirect={redirectPath}
              element={
                <ClientProvider>
                  <ShowClientApp editForm={false} match="/clientes/" />
                </ClientProvider>
              }
            />
          }
        />

        <Route
          path="/solicitud_cliente_nuevo"
          element={
            <ProtectedSentryRoute
              visible={canViewClientApplications()}
              redirect={redirectPath}
              element={<ClientApplicationApp />}
            />
          }
        />
        <Route
          path="/crear_solicitud_cliente_nuevo"
          element={
            <ProtectedSentryRoute
              visible={canViewClientApplications()}
              redirect={redirectPath}
              element={<ClientApplicationForm />}
            />
          }
        />

        <Route
          path="/segmentos"
          element={
            <ProtectedSentryRoute
              visible={canViewSegments()}
              redirect={redirectPath}
              element={<SegmentIndexApp />}
            />
          }
        />

        <Route
          path="/infaltables"
          element={
            <ProtectedSentryRoute
              visible={canViewEssentials()}
              redirect={redirectPath}
              element={<EssentialIndexView />}
            />
          }
        />

        <Route
          path="/asociar_infaltable"
          element={
            <ProtectedSentryRoute
              visible={canViewEssentials()}
              redirect={redirectPath}
              element={<EssentialsAssociationsView />}
            />
          }
        />

        <Route
          path="/listas_de_precios"
          element={
            <ProtectedSentryRoute
              visible={canViewPriceLists()}
              redirect={redirectPath}
              element={<PriceListIndexApp />}
            />
          }
        />

        <Route
          path="/crear_lista_de_precios"
          element={
            <ProtectedSentryRoute
              visible={canManagePriceLists()}
              redirect={redirectPath}
              element={<CreatePriceList />}
            />
          }
        />

        <Route
          path="/listas_de_precios/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewPriceLists()}
              redirect={redirectPath}
              element={<ShowPriceListView />}
            />
          }
        />

        <Route
          path="/precios_especiales"
          element={
            <ProtectedSentryRoute
              visible={canViewSpecialPrices()}
              redirect={redirectPath}
              element={<SpecialPriceIndexView />}
            />
          }
        />

        <Route
          path="/crear_precio_especial"
          element={
            <ProtectedSentryRoute
              visible={canManageSpecialPrices()}
              redirect={redirectPath}
              element={<CreateSpecialPrice />}
            />
          }
        />

        <Route
          path="/precios_especiales/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewSpecialPrices()}
              redirect={redirectPath}
              element={<ShowSpecialPriceView />}
            />
          }
        />

        <Route
          path="/promociones"
          element={
            <ProtectedSentryRoute
              visible={canViewPromotions()}
              redirect={redirectPath}
              element={<PromoIndexApp />}
            />
          }
        />

        <Route
          path="/nueva_promo"
          element={
            <ProtectedSentryRoute
              visible={canManagePromotions()}
              redirect={redirectPath}
              element={<CreatePromoApp />}
            />
          }
        />

        <Route
          path="/promociones/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewPromotions()}
              redirect={redirectPath}
              element={<ShowPromoView />}
            />
          }
        />

        <Route
          path="/ordenes_oc"
          element={
            <ProtectedSentryRoute
              visible={canViewPocOrders()}
              redirect={redirectPath}
              element={<OrderOcIndex />}
            />
          }
        />

        <Route
          path="/ordenes_oc_details/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewPocOrders()}
              redirect={redirectPath}
              element={<ShowOcView />}
            />
          }
        />

        <Route
          path="/ordenes_oc_details/:id/:mode"
          element={
            <ProtectedSentryRoute
              visible={canViewPocOrders()}
              redirect={redirectPath}
              element={<ShowOcView />}
            />
          }
        />

        <Route
          path="/store_relations"
          element={
            <ProtectedSentryRoute
              visible={canViewPocStoreRelations()}
              redirect={redirectPath}
              element={<StoreRelationsIndex />}
            />
          }
        />

        <Route
          path="/store_relations/new"
          element={
            <ProtectedSentryRoute
              visible={canManagePocStoreRelations()}
              redirect={redirectPath}
              element={<StoreRelationFormView />}
            />
          }
        />

        <Route
          path="/store_relations/:id/edit"
          element={
            <ProtectedSentryRoute
              visible={canManagePocStoreRelations()}
              redirect={redirectPath}
              element={<StoreRelationFormView />}
            />
          }
        />

        <Route
          path="/store_relations/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewPocStoreRelations()}
              redirect={redirectPath}
              element={<ShowStoreView />}
            />
          }
        />

        <Route
          path="/pedidos"
          element={
            <ProtectedSentryRoute
              visible={canViewOrders()}
              redirect={redirectPath}
              element={<OrderIndexApp />}
            />
          }
        />

        <Route
          path="/pedidos/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewOrders()}
              redirect={redirectPath}
              element={<ShowOrderApp />}
            />
          }
        />

        <Route
          path="/cotizaciones"
          element={
            <ProtectedSentryRoute
              visible={canViewQuotes()}
              redirect={redirectPath}
              element={<QuoteIndexApp />}
            />
          }
        />

        <Route
          path="/cotizaciones/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewQuotes()}
              redirect={redirectPath}
              element={<ShowQuoteApp />}
            />
          }
        />

        <Route
          path="/devoluciones"
          element={
            <ProtectedSentryRoute
              visible={canViewRefunds()}
              redirect={redirectPath}
              element={<RefundIndexView />}
            />
          }
        />

        <Route
          path="/devoluciones/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewRefunds()}
              redirect={redirectPath}
              element={<ShowRefundApp />}
            />
          }
        />

        <Route
          path="/entregas"
          element={
            <ProtectedSentryRoute
              visible={canViewDeliveries()}
              redirect={redirectPath}
              element={<DeliveryIndexView />}
            />
          }
        />

        <Route
          path="/ventas_a_bordo"
          element={
            <ProtectedSentryRoute
              visible={canViewOnBoardSales()}
              redirect={redirectPath}
              element={<DeliveryIndexBoardView />}
            />
          }
        />

        <Route
          path="/ventas_a_bordo/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewOnBoardSales()}
              redirect={redirectPath}
              element={<ShowDeliveryApp />}
            />
          }
        />

        <Route
          path="/entregas/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewDeliveries() || canViewReports()}
              redirect={redirectPath}
              element={<ShowDeliveryApp />}
            />
          }
        />

        <Route
          path="/asignar_entregas"
          element={
            <ProtectedSentryRoute
              visible={canViewAssignDeliveries()}
              redirect={redirectPath}
              element={<AssignDeliveryView />}
            />
          }
        />

        <Route
          path="/reporte_activos"
          element={
            <ProtectedSentryRoute
              visible={canViewAssetReports()}
              redirect={redirectPath}
              element={<ActivitiesIndexView />}
            />
          }
        />

        <Route
          path="/reporte_activos/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewAssetReports()}
              redirect={redirectPath}
              element={<ShowAssetApp />}
            />
          }
        />

        <Route
          path="/cierre_activos"
          element={
            <ProtectedSentryRoute
              visible={canViewCloseAssets()}
              redirect={redirectPath}
              element={<CollectionsIndexView />}
            />
          }
        />

        <Route
          path="/cierre_activos/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewCloseAssets()}
              redirect={redirectPath}
              element={<ShowCollectionApp />}
            />
          }
        />

        <Route
          path="/liquidaciones"
          element={
            <ProtectedSentryRoute
              visible={canViewSettlements()}
              redirect={redirectPath}
              element={<SettlementsIndex />}
            />
          }
        />

        <Route
          path="/liquidaciones/control-diario"
          element={
            <ProtectedSentryRoute
              visible={canViewDailySettlementControl()}
              redirect={redirectPath}
              element={<DailySettlementControlApp />}
            />
          }
        />

        <Route
          path="/liquidaciones/detalles/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewSettlements()}
              redirect={redirectPath}
              element={<SettlementsDetails />}
            />
          }
        />

        <Route
          path="/reportes"
          element={
            <ProtectedSentryRoute
              visible={canViewReports()}
              redirect={redirectPath}
              element={<EffectivenessIndexApp />}
            />
          }
        />

        <Route
          path="/crear_usuario_configuracion"
          element={
            <ProtectedSentryRoute
              visible={canManageUsersApp()}
              redirect={redirectPath}
              element={<CreateUsersForm />}
            />
          }
        />

        <Route
          path="/facturas/:id"
          element={
            <ProtectedSentryRoute
              visible={shouldViewCoreInfo}
              redirect={redirectPath}
              element={<ShowInvoiceApp />}
            />
          }
        />

        <Route
          path="/usuario_reportes"
          element={
            <ProtectedSentryRoute
              visible={canViewReports()}
              redirect={redirectPath}
              element={<ShowUserView />}
            />
          }
        />

        <Route
          path="/visitas-no-efectivas/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewReports()}
              redirect={redirectPath}
              element={<ShowNoEffectiveVisitApp />}
            />
          }
        />

        <Route
          path="/cobros"
          element={
            <ProtectedSentryRoute
              visible={canViewCharges()}
              redirect={redirectPath}
              element={<ChargeIndexView />}
            />
          }
        />

        <Route
          path="/cobros/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewCharges()}
              redirect={redirectPath}
              element={<ShowChargeApp />}
            />
          }
        />

        <Route
          path="/tareas_en_sitio/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewPosTasks()}
              redirect={redirectPath}
              element={<PosTaskApp />}
            />
          }
        />

        <Route
          path="/ejecucion_punto_venta"
          element={
            <ProtectedSentryRoute
              visible={canViewPosTasks()}
              redirect={redirectPath}
              element={<PointOfSaleApp />}
            />
          }
        />

        <Route
          path="/ejecucion_punto_venta/detalles/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewPosTasks()}
              redirect={redirectPath}
              element={<PosDetailsApp />}
            />
          }
        />

        <Route
          path="/efectividad_de_tareas"
          element={
            <ProtectedSentryRoute
              visible={canViewPosEffectiveness()}
              redirect={redirectPath}
              element={<PosTaskEffectivityApp />}
            />
          }
        />

        <Route
          path="/crear_tarea_punto_venta"
          element={
            <ProtectedSentryRoute
              visible={canManagePosTasks()}
              redirect={redirectPath}
              element={<TaskLayout />}
            />
          }
        />

        <Route
          path="/descarga_analisis_pdv"
          element={
            <ProtectedSentryRoute
              visible={canViewPosAnalysisDownload()}
              redirect={redirectPath}
              element={<PosDownloadApp />}
            />
          }
        />

        <Route
          path="/plan_de_visitas"
          element={
            <ProtectedSentryRoute
              visible={canViewRoutePlans()}
              redirect={redirectPath}
              element={<RoutePlanIndexView />}
            />
          }
        />

        <Route
          path="/crear_plan_de_visita"
          element={
            <ProtectedSentryRoute
              visible={canManageRoutePlans()}
              redirect={redirectPath}
              element={<CreateNewRoutePlan />}
            />
          }
        />

        <Route
          path="/plan_de_visitas/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewRoutePlans()}
              redirect={redirectPath}
              element={<ShowRoutePlanView />}
            />
          }
        />

        <Route
          path="/usuarios"
          element={
            <ProtectedSentryRoute
              visible={canViewUsersApp()}
              redirect={redirectPath}
              element={
                <UserInfoProvider>
                  <UsersIndexApp />
                </UserInfoProvider>
              }
            />
          }
        />

        <Route
          path="/usuarios/:uid"
          element={
            <ProtectedSentryRoute
              visible={canViewUsersApp()}
              redirect={redirectPath}
              element={
                <UserInfoProvider>
                  <UserConfigProvider>
                    <UserStepTabsProvider>
                      <TabsUserConfig />
                    </UserStepTabsProvider>
                  </UserConfigProvider>
                </UserInfoProvider>
              }
            />
          }
        />

        <Route
          path="/usuarios_asignados/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewUsersApp()}
              redirect={redirectPath}
              element={<UsersByClientRoute />}
            />
          }
        />

        <Route
          path="/metricas_gerencia/productos_con_diferencias"
          element={
            <ProtectedSentryRoute
              visible={canViewPocFillRate()}
              redirect={redirectPath}
              element={<FillRateProductDifferences />}
            />
          }
        />

        <Route
          path="/metricas_gerencia"
          element={
            <ProtectedSentryRoute
              visible={canViewPocFillRate()}
              redirect={redirectPath}
              element={<MetricsIndex />}
            />
          }
        />

        <Route
          path="/configuracion/rbac/roles"
          element={
            <ProtectedSentryRoute
              visible={canViewRbacRoles()}
              redirect={redirectPath}
              element={<RbacRolesListPage />}
            />
          }
        />
        <Route
          path="/configuracion/rbac/roles/nuevo"
          element={
            <ProtectedSentryRoute
              visible={canManageRbacRoles()}
              redirect={redirectPath}
              element={<CreateRbacRoleWizard />}
            />
          }
        />
        <Route
          path="/configuracion/rbac/roles/:id/editar"
          element={
            <ProtectedSentryRoute
              visible={canManageRbacRoles()}
              redirect={redirectPath}
              element={<CreateRbacRoleWizard />}
            />
          }
        />
        <Route
          path="/configuracion/rbac/roles/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewRbacRoles()}
              redirect={redirectPath}
              element={<RbacRoleDetailPage />}
            />
          }
        />
        <Route
          path="/configuracion/rbac/asignar"
          element={
            <ProtectedSentryRoute
              visible={canViewRbacUsers()}
              redirect={redirectPath}
              element={<AssignRbacRolesPage />}
            />
          }
        />
        <Route
          path="/configuracion/rbac/usuarios/:id"
          element={
            <ProtectedSentryRoute
              visible={canViewRbacUsers()}
              redirect={redirectPath}
              element={<RbacUserDetailPage />}
            />
          }
        />

        <Route
          path="*"
          element={redirectPath ? <Navigate to={`/${redirectPath}`} replace /> : <NotFoundPage />}
        />
      </Routes>
    </MainLayout>
  )
}
export default App
